const DEFAULT_ZONE = 'Europe/London';

/** Times are stored in UTC and shown in the organisation's time zone (Europe/London until the portal can read the tenant's). */
export function formatDateTime(iso: string | null | undefined, timeZone = DEFAULT_ZONE): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'short', timeZone }).format(d);
}

export function formatMonth(periodDate: string): string {
  const d = new Date(`${periodDate}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return periodDate;
  return new Intl.DateTimeFormat('en-GB', { month: 'short', year: 'numeric', timeZone: 'UTC' }).format(d);
}

export function formatNumber(n: number): string {
  return new Intl.NumberFormat('en-GB').format(n);
}

export function formatBytes(n: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${new Intl.NumberFormat('en-GB', { maximumFractionDigits: i === 0 ? 0 : 1 }).format(v)} ${units[i]}`;
}
